/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from './cardtoggle_styles';



/* ========== ~~~~~~~~~~ CARD TOGGLE ~~~~~~~~~~ ========== */
const CardToggle = injectSheet(styles)((props) => {
    const handleClick = (e) => { if(!!props.handleClick) props.handleClick(props.label) };
    // console.log((new Date('2021-04-31') - new Date('2020-04-01'))/ (1000 * 60 * 60 * 24));
    const percentChangeTextColor = props.percentChange.direction === 'up' ?
      'rgb(102, 206, 110)' :
      props.percentChange.direction === 'down' ?
        'rgb(252, 79, 161)' :
        'rgba(6, 43, 117, 0.5)';
    const percentChangeContainerColor = props.percentChange.direction === 'up' ?
      'rgb(243, 251, 244)' :
      props.percentChange.direction === 'down' ?
        'rgb(254, 242, 248)' :
        'rgba(6, 43, 117, 0.1)';

    const showMonetizationRateChange = (props.metricType === 'monetization' && props.compareType && props.compareType.toLowerCase() !== 'pop');
    const showProductAnalyticsRateChange = (props.metricType === 'commenting' || props.metricType === 'trivia' || props.metricType === 'trending');

    return (
      <div className={`cardtoggle ${props.classes.cardtoggle} isActive-${props.selected}`} onClick={handleClick}>
        <div className={'selectedbar'} />
        <div className={'content'}>
          <span className={'label'}>{props.label}{!!props.totalPercent && ` (${props.totalPercent})` }</span>
          <span className={'value'}>{props.value}</span>
          { showMonetizationRateChange || showProductAnalyticsRateChange ?
            <div className={'compare'}>
                <div className={'percent'} style={{color: percentChangeTextColor, background: percentChangeContainerColor}}>
                    {props.percentChange.direction === 'up' ? '↑ ' : props.percentChange.direction === 'down' ? '↓ ' : ''}
                    {props.percentChange.value}</div>
                <span>{props.compareType}</span>
            </div>
            :
            <div className={'compare'}><div className={'percent'}></div></div>
          }
        </div>
      </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CardToggle;
